module.exports = {
  "country": "RU",
  "artist": "Dima Bilan",
  "song": "Believe",
  "year": "2008",
  "place": "1",
  "spotify": "3cSspMBbG6WJq3Whm9v8av"
};